import Cookies from 'js-cookie';
import {
  LoginFormI,
  RegisterFormI,
  ForgetPasswordPayload,
  ResetPasswordPayload,
  VerifyOtpI,
  ResendOtpI
} from 'src/models/auth';
import {
  apiRequest,
  customerApiRequest,
  publicApiRequest
} from 'src/utils/api';
import { jwtDecode } from 'jwt-decode';
import { timestampToDate } from 'src/utils/date';
import { RoutePath } from 'src/enums/routePath';
import { ApiPath } from 'src/enums/apiPath';
import {
  ACCESS_TOKEN_KEY,
  CUSTOMER_ACCESS_TOKEN_KEY
} from 'src/constants/auth';

export const login = async (payload: LoginFormI) => {
  const res = await apiRequest.post({
    url: ApiPath.LOGIN,
    data: payload
  });

  const accessToken = res?.data?.data?.access_token;
  const decoded = jwtDecode(accessToken);
  const expiredDate = timestampToDate(Number(decoded?.exp));

  if (!!accessToken) {
    Cookies.set(ACCESS_TOKEN_KEY, accessToken, {
      expires: expiredDate
    });
  }

  return res;
};

export const logout = () => {
  Cookies.remove(ACCESS_TOKEN_KEY);
  window.location.replace(RoutePath.LOGIN);
};

export const customerForgetPassword = async (data: ForgetPasswordPayload) => {
  return publicApiRequest.post({
    url: ApiPath.CUSTOMER_FORGOT_PASSWORD,
    data
  });
};

export const customerResetPassword = async (data: ResetPasswordPayload) => {
  const res = await publicApiRequest.post({
    url: ApiPath.CUSTOMER_RESET_PASSWORD,
    data
  });

  return res.data;
};

export const checkCustomerResetPwToken = async (token: string) => {
  const res = await publicApiRequest.post({
    url: ApiPath.CUSTOMER_CHECK_RESET_TOKEN,
    data: {
      token
    }
  });

  return res.data;
};

export const customerLogin = async (payload: LoginFormI) => {
  const res = await customerApiRequest.post({
    url: ApiPath.CUSTOMER_LOGIN,
    data: payload
  });

  const accessToken = res?.data?.data?.access_token;
  const decoded = jwtDecode(accessToken);
  const expiredDate = timestampToDate(Number(decoded?.exp));

  if (!!accessToken) {
    Cookies.set(CUSTOMER_ACCESS_TOKEN_KEY, accessToken, {
      expires: expiredDate
    });
  }

  return res;
};

export const customerOtpLogin = async (payload: LoginFormI) => {
  const res = await publicApiRequest.post({
    url: ApiPath.CUSTOMER_LOGIN_OTP,
    data: payload
  });

  return res.data;
};

export const customerVerifyOtp = async (payload: VerifyOtpI) => {
  const res = await publicApiRequest.post({
    url: ApiPath.CUSTOMER_VERIFY_OTP,
    data: payload
  });

  const accessToken = res?.data?.data?.access_token;
  const decoded = jwtDecode(accessToken);
  const expiredDate = timestampToDate(Number(decoded?.exp));

  if (!!accessToken) {
    Cookies.set(CUSTOMER_ACCESS_TOKEN_KEY, accessToken, {
      expires: expiredDate
    });
  }

  return res.data;
};

export const customerResendOtp = async (payload: ResendOtpI) => {
  const res = await publicApiRequest.post({
    url: ApiPath.CUSTOMER_RESEND_OTP,
    data: payload
  });

  return res.data;
};

export const handleCustomerLogout = () => {
  Cookies.remove(CUSTOMER_ACCESS_TOKEN_KEY);
  window.location.replace(RoutePath.CUSTOMER + RoutePath.LOGIN);
};

export const adminForgetPassword = async (data: ForgetPasswordPayload) => {
  return publicApiRequest.post({
    url: ApiPath.ADMIN_FORGOT_PASSWORD,
    data
  });
};

export const checkAdminResetPwToken = async (token: string) => {
  const res = await publicApiRequest.post({
    url: ApiPath.ADMIN_CHECK_RESET_TOKEN,
    data: {
      token
    }
  });

  return res.data;
};

export const adminResetPassword = async (data: ResetPasswordPayload) => {
  const res = await publicApiRequest.post({
    url: ApiPath.ADMIN_RESET_PASSWORD,
    data
  });

  return res.data;
};

export const handleAdminLogout = () => {
  Cookies.remove(ACCESS_TOKEN_KEY);
  window.location.replace(RoutePath.ADMIN + RoutePath.LOGIN);
};
